// 格式化方法可用于全局过滤器
import { parseTime } from '@/utils/tools'
/* eslint-disable no-new */
// 全局过滤器
const filters = {
  parseTime
}

export default filters



// WEBPACK FOOTER //
// ./src/filter/index.js